export default {
	maxDateMessage: "Das Datum sollte nicht nach dem maximalen Datum liegen.",
	minDateMessage: "Das Datum sollte nicht vor dem Mindestdatum liegen.",
}